<template>
    <base-section
    id="alternative-hotels"
    >
      <v-container>
      <base-section-heading
      title="Alternative Hotels"
      color="secondary"
      align="left"
      :toColor="true"
      >
      There are also two alternative options connected to the conference: the <strong><a href="https://www.samawihotel.com/" target="_blank">SAMAWI Hotel</a></strong> and the <strong><a href="https://www.hotelaquamare.com/" target="_blank">Hotel Aquamare</a></strong>.
      </base-section-heading>
      <base-section-heading
      title="SAMAWI Hotel"
      color="secondary"
      align="left"
      :toColor="true"
      >
      You can find the location of the <strong><a href="https://www.samawihotel.com/" target="_blank">SAMAWI Hotel</a></strong> hotel <a href="https://maps.app.goo.gl/Pot7W2m1wu9S98Sz7" target="_blank">here</a>.<br>
      <br>
      <v-btn
        href="https://www.samawihotel.com/"
        target="_blank"
        rounded
        color="primary"
        dark
        style="padding: 15px"
        class="nowrap"
      >
        <v-icon
          left
          dark
        >
          mdi-open-in-new
        </v-icon>
        Visit the SAMAWI Hotel website
      </v-btn>
      <br><br>
      The hotel is at a walkable distance to the conference hotel, please check <a href="https://maps.app.goo.gl/wQY9gWaDnSU3m2pu9" target="_blank">here the path</a>.
      <br><br>
      <iframe
    src="https://www.google.com/maps/embed?pb=!1m28!1m12!1m3!1d3843.297087105846!2d-81.69369407493015!3d12.582237187698489!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!4m13!3e6!4m5!1s0x8f05af55bf09b6f5%3A0xae4b793c1fe70830!2sSamawi%2C%20Cra.%201%20%2321%2C%20San%20Andr%C3%A9s%2C%20San%20Andr%C3%A9s%20y%20Providencia%2C%20Colombia!3m2!1d12.580497099999999!2d-81.6897757!4m5!1s0x8f05af55eb2e2b9f%3A0x5cbb12dab6d00e6e!2sHotel%20Casablanca%2C%20Avenida%20Colombia%2C%20Islas%2C%20San%20Andr%C3%A9s%20y%20Providencia%2C%20Colombia!3m2!1d12.5841201!2d-81.6923597!5e1!3m2!1sit!2sit!4v1736845893178!5m2!1sit!2sit"
    width="80%"
    height="450"
    style="border:0;"
    allowfullscreen=""
    loading="lazy"
    referrerpolicy="no-referrer-when-downgrade"
    ></iframe>
      </base-section-heading>
  <base-section-heading
      title="SAMAWI Hotel - Booking procedure"
      color="secondary"
      align="left"
      :toColor="true"
      >
      The costs in <strong>SAMAWI</strong> for the conference are the following:<br><br>

  - Standard Single Room (1 person):  COP $570.000 per night<br>
  - Standard Double Room (2 persons): COP $700.000 per night<br>

  Breakfast is included.<br><br>

  <strong>In order to obtain the LATS2025 price, please book your hotel via email writing an email as follows:</strong><br>

  - <strong>Email subject</strong>: LATS2025 room reservation<br>

  - <strong>To</strong>: Tivisai Colon C.<br>

  - <strong>Email address</strong>: reservas@samawihotel.com<br><br>

  Please, while booking <strong>include the following email in c.c. : lats2025@gmail.com</strong><br>

  In this way, we may support you during the reservation process.

    </base-section-heading>
    <base-section-heading
      title="Hotel Aquamare"
      color="secondary"
      align="left"
      :toColor="true"
      >
      You can find the location of the <strong><a href="https://www.hotelaquamare.com/" target="_blank">Hotel Aquamare</a></strong> <a href="https://maps.app.goo.gl/PerHmpsjmbzrHmgC8" target="_blank">here</a>.<br>
      <br>
      <v-btn
        href="https://www.hotelaquamare.com/"
        target="_blank"
        rounded
        color="primary"
        dark
        style="padding: 15px"
        class="nowrap"
      >
        <v-icon
          left
          dark
        >
          mdi-open-in-new
        </v-icon>
        Visit the Hotel AQUAMARE website
      </v-btn>
      <br><br>
      The hotel is at a walkable distance to the conference hotel, please check <a href="https://maps.app.goo.gl/ss51AxN7SyfKhzJQ6" target="_blank">here the path</a>.
      <br><br>
      <iframe
    src="https://www.google.com/maps/embed?pb=!1m28!1m12!1m3!1d3843.2867801597977!2d-81.6946716249301!3d12.582925587697876!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!4m13!3e2!4m5!1s0x8f05a5d3a5b0f40b%3A0xf06ac420e243682c!2sAquamare%20Hotel%2C%20Cra.%202%20%23Calle%202%201B-128%2C%20San%20Andr%C3%A9s%2C%20San%20Andr%C3%A9s%20y%20Providencia%2C%20Colombia!3m2!1d12.581965499999999!2d-81.69141239999999!4m5!1s0x8f05af55eb2e2b9f%3A0x5cbb12dab6d00e6e!2sHotel%20Casablanca%2C%20Avenida%20Colombia%2C%20Islas%2C%20San%20Andr%C3%A9s%20y%20Providencia%2C%20Colombia!3m2!1d12.5841201!2d-81.6923597!5e1!3m2!1sit!2sit!4v1737463025766!5m2!1sit!2sit"
    width="80%"
    height="450"
    style="border:0;"
    allowfullscreen=""
    loading="lazy"
    referrerpolicy="no-referrer-when-downgrade"
    ></iframe>
      </base-section-heading>
  <base-section-heading
      title="Hotel AQUAMARE - Booking procedure"
      color="secondary"
      align="left"
      :toColor="true"
      >
      The costs in <strong>AQUAMARE</strong> for the conference are the following:<br><br>

  - Standard Single Room (1 person):  COP $650.000 per night<br>
  - Standard Double Room (2 persons): COP $660.000 per night<br>

  Breakfast is included.<br><br>

  <strong>In order to obtain the LATS2025 price, please book your hotel via email writing an email as follows:</strong><br>

  - <strong>Email subject</strong>: LATS2025 room reservation<br>

  - <strong>To</strong>: Betani Morales<br>

  - <strong>Email address</strong>: reservas@hotelaquamare.com<br><br>

  Please, while booking <strong>include the following email in c.c. : lats2025@gmail.com</strong><br>

  In this way, we may support you during the reservation process.

    </base-section-heading>
      </v-container>
    </base-section>
  </template>

  <script>
    export default {
      name: 'AlternativeHotels',

      data: () => ({
        slides: [

        ],
      }),
    }
  </script>

  <style>
  .v-application .grey--text.text--darken-1 {
    color: black !important;
  }
  .nowrap .v-btn__content {
    width: 100%;
    white-space: break-spaces;
    text-align: center;
  }
  </style>
